import { IFiltersState } from '../components/VacanciesBlock/VacanciesBlock';
import { getQueryFromArray } from '../utils/get-query-from-array';
import api from './api';

async function searchVacancyGroupAPI(searchValue: string, division: string, filterValues: IFiltersState) {
  const response = await api.get(
    `vacancy_group_search/?division=${division}${searchValue
      ? `&search=${encodeURIComponent(decodeURIComponent(searchValue))}` : ''}${filterValues.city.length > 0
        && !filterValues.city.includes('Любой')
      ? `&city=${getQueryFromArray(filterValues.city)}` : ''}${filterValues.workFormat.length > 0
      ? `&workFormat=${getQueryFromArray(filterValues.workFormat)}` : ''}${filterValues.employmentType.length > 0
      ? `&employmentType=${getQueryFromArray(filterValues.employmentType)}` : ''}${filterValues.grade.length > 0
      ? `&grade=${getQueryFromArray(filterValues.grade)}` : ''}`,
  );
  return response?.data;
}

export default searchVacancyGroupAPI;
